import { AlertsPrimaryDarkIcon, AlertsPrimaryIcon, AutomationPrimaryDarkIcon, AutomationPrimaryIcon, ChangepasswordPrimaryDarkIcon, ChangepasswordPrimaryIcon, ContactsPrimaryDarkIcon, ContactsPrimaryIcon, ConversationsPrimaryDarkIcon, ConversationsPrimaryIcon, DashboardPrimaryDarkIcon, DashboardPrimaryIcon, FalkonAiPurpleIcon, FalkonDocIcon, FalkonDocPrimaryIcon, FeaturesPrimaryDarkIcon, FeaturesPrimaryIcon, GroupsPrimaryDarkIcon, GroupsPrimaryIcon, IntegrationPrimaryDarkIcon, IntegrationPrimaryIcon, KafkaPrimaryDarkIcon, KafkaPrimaryIcon, OrganizationsPrimaryDarkIcon, OrganizationsPrimaryIcon, PhoneGroupPrimaryDarkIcon, PhoneGroupPrimaryIcon, PhoneNumbersPrimaryDarkIcon, PhoneNumbersPrimaryIcon, PlansPrimaryDarkIcon, PlansPrimaryIcon, ReportsPrimaryDarkIcon, ReportsPrimaryIcon, ScheduleMessagePrimaryDarkIcon, ScheduleMessagePrimaryIcon, SecureChatActiveIcon, SecureChatGreyIcon, SecureFilePrimaryDarkIcon, SecureFilePrimaryIcon, SettingBlockedActiveIcon, SettingCustomeSignActiveIcon, SettingGeneralActiveIcon, SettingsBlockedIcon, SettingsCustomSignIcon, SettingsGeneralIcon, SettingsLowCreditNotifyIcon, SettingsNotificationActiveIcon, SettingsNotificationIcon, SettingsPrimaryDarkIcon, SettingsPrimaryIcon, SettingsScheduledReportActiveIcon, SettingsScheduledReportIcon, SettingsUnsubscribedIcon, SettingUnsubActiveIcon, TemplatesPrimaryDarkIcon, TemplatesPrimaryIcon, TiersPrimaryDarkIcon, TiersPrimaryIcon, TransferPrimaryDarkIcon, TransferPrimaryIcon, UsersPrimaryDarkIcon, UsersPrimaryIcon } from "../../icon";
import { PlanMetrics, UserPlanTracker } from "../../models/plan-metrics.model";
import { lazy } from 'react';
import { withErrorBoundaries } from "../shared/error-handler.component";
import { TeamsRoutes } from "./route.path";
import { RouteModel } from "../../models/routes.model";
import store from '../../stores/app-store';
// const AddPhoneNumber = lazy(() => import("../add-phone-number"));
// const AlertsComponent = lazy(() => import('../alerts/alerts.component'));
// const AutoAlertKeyword = lazy(() => import("../auto-alerts/keywords.component"));
// const AutoAlertLogs = lazy(() => import("../auto-alerts/logs.component"));
// const AutoAlertRules = lazy(() => import("../auto-alerts/rules.component"));
// const Contacts = lazy(() => import("../contacts/contact.component"));
// const ImportContacts = lazy(() => import("../contacts/import-dailog.component.new"));
// const Dashboard = lazy(() => import("../dashboard/dashboard-view.component"));
// const Features = lazy(() => import("../features/feature.component"));
// const Groups = lazy(() => import("../groups"));
// const Organizations = lazy(() => import("../organizations/organization.component"));
// const PaymentStatusComponent = lazy(() => import('../payment/payment-status.component'));
// const PhoneNumber = lazy(() => import("../phone-numbers/phone-number.component"));
// const PlansHistoryComponent = lazy(() => import("../plans/plans-history.component"));
// const Plans = lazy(() => import("../plans/plans.component"));
// const Changepassword = lazy(() => import("../profile/change-password.component"));
// const Profile = lazy(() => import("../profile/profile.component"));
// const Recharge = lazy(() => import("../recharge"));
// const Reports = lazy(() => import('../reports/index'));
// const ScheduledMessage = lazy(() => import('../scheduled-messages/scheduled-messages.component'));
// const Settings = lazy(() => import("../settings/settings.component"));
// const TemplateComponent = lazy(() => import("../templates"));
// const Tiers = lazy(() => import("../tiers/tier.component"));
// const Transfers = lazy(() => import("../transfers"));
// const Users = lazy(() => import("../users/user.component"));
// const MicrosoftLoginConsentEnd = lazy(() => import("../contacts/microsoftLogin/microsoft-login-end.component"));
// const MicrosoftLoginStart = lazy(() => import("../contacts/microsoftLogin/microsoft-login-start.component"));
// const ConversationComponent = lazy(() => import('../conversations/conversation-component'));
// const Integrations = lazy(() => import('../integrations'));
// const ClioCallback = lazy(() => import('../integrations/clio/clio-callback'));
// const ClioPopup = lazy(() => import('../integrations/clio/clio-popup'));
// const ClioSetup = lazy(() => import('../integrations/clio/clio-setup'));
// const HubSpotCallback = lazy(() => import("../integrations/hubspot/hubspot-callback"));
// const HubSpotPopup = lazy(() => import("../integrations/hubspot/hubspot-popup"));
// const HubSpotSetup = lazy(() => import("../integrations/hubspot/hubspot-setup"));
// const kafkaComponent = lazy(() => import('../kafka-component'));
// const ForgotPassword = lazy(() => import('../login/forgot-password.component'));
// const Login = lazy(() => import('../login/login.component'));
// const MicrosoftLoginStartSSO = lazy(() => import('../login/MicrosoftSSO/microsoft-teams-start.component'));
// const MicrosoftLoginConsentEndSSO = lazy(() => import('../login/MicrosoftSSO/microsoft-teams-stop.component'));
// const ResetPassword = lazy(() => import('../login/reset-password.component'));
// const TwofactorAuthentication = lazy(() => import('../login/twofactor-authentication.component'));
// const CreditLogsComponent = lazy(() => import('../reports/credit-logs-component'));
// const ExportMsgLogsComponent = lazy(() => import('../reports/message-logs/export-msg-log-component'));
// const MessageLogs = lazy(() => import("../reports/message-logs/message-logs.component"));
// const SecureFiles = lazy(() => import("../secure-file"));
// const FaceRegister = lazy(() => import("../secure-file/face-register.component"));
// const FaceVerification = lazy(() => import("../secure-file/face-verification.component"));
// const SecureFileEmailAuthentication = lazy(() => import('../secure-file/secure-file-email-authentication'));
// const SsoInactive = lazy(() => import('../shared/sso-inactive.component'));
// const Signup = lazy(() => import('../signup'));
// const OutlookSetUp = lazy(() => import('../integrations/Outlook'));
// const OutlookPopup = lazy(() => import('../integrations/Outlook/outlook-popup'));
// const OutlookCallback = lazy(() => import('../integrations/Outlook/outlook-callback'));
// const ImportContactsContainer = lazy(() => import('../contacts/import-contact-container.component'));
// const OptOutPolicy = lazy(() => import('../reports/optout-policy.component'));
// const BlockedContact = lazy(() => import('../reports/blocked-contacts.component'));
// const SlackChannelSetup = lazy(() => import('../integrations/slack/slack-setup'));
// const SlackPopup = lazy(() => import('../integrations/slack/slack-popup'));
// const SlackCallback = lazy(() => import('../integrations/slack/slack-callback'));
// const FalkonAi = lazy(() => import('../falkon-ai'));

import AddPhoneNumber from "../add-phone-number";
import AlertsComponent from '../alerts/alerts.component';
import AutoAlertRules from "../auto-alerts/rules.component";
import Contacts from "../contacts/contact.component";
import ImportContacts from "../contacts/import-dailog.component.new";
import Dashboard from "../dashboard/dashboard-view.component";
import Features from "../features/feature.component";
import Groups from "../groups";
import Organizations from "../organizations/organization.component";
import PaymentStatusComponent from '../payment/payment-status.component';
import PhoneNumber from "../phone-numbers/phone-number.component";
import PlansHistoryComponent from "../plans/plans-history.component";
import Plans from "../plans/plans.component";
import Changepassword from "../profile/change-password.component";
import Profile from "../profile/profile.component";
import Recharge from "../recharge";
import Reports from '../reports/index';
import ScheduledMessage from '../scheduled-messages/scheduled-messages.component';
import Settings from "../settings/settings.component";
import TemplateComponent from "../templates";
import Tiers from "../tiers/tier.component";
import Transfers from "../transfers";
import Users from "../users/user.component";
import MicrosoftLoginConsentEnd from "../contacts/microsoftLogin/microsoft-login-end.component";
import MicrosoftLoginStart from "../contacts/microsoftLogin/microsoft-login-start.component";
import ConversationComponent from '../conversations/conversation-component';
import Integrations from '../integrations';
import ClioCallback from '../integrations/clio/clio-callback';
import ClioPopup from '../integrations/clio/clio-popup';
import ClioSetup from '../integrations/clio/clio-setup';
import HubSpotCallback from "../integrations/hubspot/hubspot-callback";
import HubSpotPopup from "../integrations/hubspot/hubspot-popup";
import HubSpotSetup from "../integrations/hubspot/hubspot-setup";
import kafkaComponent from '../kafka-component';
import ForgotPassword from '../login/forgot-password.component';
import Login from '../login/login.component';
import MicrosoftLoginStartSSO from '../login/MicrosoftSSO/microsoft-teams-start.component';
import MicrosoftLoginConsentEndSSO from '../login/MicrosoftSSO/microsoft-teams-stop.component';
import ResetPassword from '../login/reset-password.component';
import TwofactorAuthentication from '../login/twofactor-authentication.component';
import CreditLogsComponent from '../reports/credit-logs-component';
import ExportMsgLogsComponent from '../reports/message-logs/export-msg-log-component';
import MessageLogs from "../reports/message-logs/message-logs.component";
import SecureFiles from "../secure-file";
import FaceRegister from "../secure-file/face-register.component";
import FaceVerification from "../secure-file/face-verification.component";
import SecureFileEmailAuthentication from '../secure-file/secure-file-email-authentication';
import SsoInactive from '../shared/sso-inactive.component';
import Signup from '../signup';
import OutlookSetUp from '../integrations/Outlook';
import OutlookPopup from '../integrations/Outlook/outlook-popup';
import OutlookCallback from '../integrations/Outlook/outlook-callback';
import ImportContactsContainer from '../contacts/import-contact-container.component';
import OptOutPolicy from '../reports/optout-policy.component';
import BlockedContact from '../reports/blocked-contacts.component';
import SlackChannelSetup from '../integrations/slack/slack-setup';
import SlackPopup from '../integrations/slack/slack-popup';
import SlackCallback from '../integrations/slack/slack-callback';
import FalkonAi from '../falkon-ai';
import PhoneNumberGroups from '../PhoneNumberGroup';
import SecureDocs from '../falkon-docs/index';
import SecureDocsUploads from '../falkon-docs/falkon-docs-uploads';
import AddRecipientComponent from '../falkon-docs/add-recipients-component';
import DisplaySuccessMaessageComponent from '../falkon-docs/display-success-message.component';
import FalkonSecureDocOtp from '../falkon-docs/secure-doc-otp-verification.component';
import EndUserSigningComponent from '../falkon-docs/end-user-signing.component';
import DisplaySignerSuccessMaessageComponent from '../falkon-docs/display-signer-success-message.component';
import FalkonSignedSecureDocOtp from '../falkon-docs/signed-secure-doc-otp-verification.component';
import CompletedPDFViewerComponent from '../falkon-docs/completed-secure-doc-view.component';
import { LocalStorage } from '../../services/UtilityService';
import ImportScheduleMessages from '../scheduled-messages/import-schedule-messages';
import NewUsers from '../new-Users/NewUsers';
import ImportUsersComponent from '../new-Users/import-users.component';
import UserImportReports from '../new-Users/UserImportReports';
import NewNumberBulkImportComponent from '../new-PhoneNumbers/NewNumberBulkImportComponent';
import PhoneHostImportReports from '../new-PhoneNumbers/PhoneHostImportReports';
import NewOrganization from '../new-Organizations/NewOrganization';
import NewPhoneNumbers from '../new-PhoneNumbers/NewPhoneNumbers';
import NewPlans from '../new-subscription-flow/NewPlans';
import CreateEditPlan from '../new-subscription-flow/CreateEditPlan';
import NewRecharge from '../new Recharge/NewRecharge';
import NewAddPhoneNumber from '../new-PhoneNumbers/NewAddPhoneNumber';
import OrgPlanHistoryComponent from '../new-Organizations/planHistory';
import NewPaymentStatus from '../new-PhoneNumbers/NewPaymentStatus';
import AccountBilling from '../account-billing/Account-billing';
import ViewTierComponent from "../tiers/view-tier";
import CustomAttributesComponent from "../contacts/custom-attributes.component";
import WebForm from "../web-forms";
import WebFormHistory from "../web-forms/webform-histoy.component";
import SecureChatMessageLogs from "../reports/message-logs/secure-chat-message-logs";
import SecureChatExportMsgLogsComponent from "../reports/message-logs/secure-chat-export-history.component";
import StepperImportNewComponent from "../contacts/stepper-import.newcomponent";

let existing_routes: RouteModel[] = [];
let user_id: string = "";

export const TeamRoutes = () => {
	const currentUser = LocalStorage.get("current-user")
	const isNewSubFlow = currentUser?.isNewSubFlow ?? false
	const userId = currentUser?.id ?? ""
	if (existing_routes?.length === 0 || user_id !== userId) {
		const routes: RouteModel[] = [
			{
				id: 1,
				path: TeamsRoutes.DASHBOARD,
				label: "Dashboard",
				component: withErrorBoundaries(Dashboard, "Dashboard"),
				primaryIcon: DashboardPrimaryIcon,
				primaryDarkIcon: DashboardPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [2, 3, 4]
			},
			{
				id: 2,
				path: `${TeamsRoutes.PLANS}/*`,
				label: isNewSubFlow ? "Phone Lines" : "Phone Lines",
				component: withErrorBoundaries(Plans, "Plans"),
				primaryIcon: PlansPrimaryIcon,
				primaryDarkIcon: PlansPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [2, 4],
				exact: true
			},
			{
				id: 3,
				path: TeamsRoutes.ORGANIZATIONS,
				label: "Organizations",
				component: withErrorBoundaries(Organizations, "Organizations"),
				primaryIcon: OrganizationsPrimaryIcon,
				primaryDarkIcon: OrganizationsPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1]
			},
			{
				id: 4,
				path: TeamsRoutes.PHONE_NUMBERS,
				label: "Phone Numbers",
				component: withErrorBoundaries(PhoneNumber, "Phone Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1]
			},
			{
				id: 155,
				label: "PhoneNumberGroups",
				path: TeamsRoutes.PHONENUMBER_GROUPS_SYSADM,
				component: withErrorBoundaries(PhoneNumberGroups, "PhoneNumberGroups"),
				primaryIcon: PhoneGroupPrimaryIcon,
				primaryDarkIcon: PhoneGroupPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},
			{
				id: 5,
				path: isNewSubFlow ? TeamsRoutes.NEW_USERS : TeamsRoutes.USERS,
				label: "Users",
				component: withErrorBoundaries(isNewSubFlow ? NewUsers : Users, "Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1, 2, 4]
			},
			{
				id: 6,
				path: `${TeamsRoutes.CONVERSATIONS}/*`,
				label: "Conversations",
				component: withErrorBoundaries(ConversationComponent, "Conversations"),
				primaryIcon: ConversationsPrimaryIcon,
				primaryDarkIcon: ConversationsPrimaryDarkIcon,
				isSideMenu: true,
				enableHighlight: true,
				highlightDataKey: "unreadMessageCount",
				authenticationRequired: true,
				roles: [2, 3, 4]
			},
			{
				id: 7,
				label: "Secure Chat",
				path: `${TeamsRoutes.SECURE_CONVERSATIONS}/*`,
				component: withErrorBoundaries(ConversationComponent, "Conversations"),
				primaryIcon: SecureChatGreyIcon,
				primaryDarkIcon: SecureChatActiveIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				highlightDataKey: "secureChatUnReadMessageCount",
				enableHighlight: true,
				hasSubRoutes: false,
				exact: true,
				PlanFilter: "HasAccessToSecureChat",
			},
			{
				id: 8,
				path: TeamsRoutes.SCHEDULED_MESSAGES,
				label: "Scheduled",
				component: withErrorBoundaries(ScheduledMessage, "Scheduled Messages"),
				primaryIcon: ScheduleMessagePrimaryIcon,
				primaryDarkIcon: ScheduleMessagePrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [2, 3, 4],
				PlanFilter: "HasMessageScheduling",
				exact: true
			},
			{
				id: 9,
				path: TeamsRoutes.CONTACTS,
				label: "Contacts",
				component: withErrorBoundaries(Contacts, "Contacts"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [2, 3, 4],
				exact: true,
			},
			{
				id: 10,
				path: TeamsRoutes.GROUPS,
				label: "Groups (Campaigns)",
				component: withErrorBoundaries(Groups, "Groups"),
				primaryIcon: GroupsPrimaryIcon,
				primaryDarkIcon: GroupsPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [2, 3, 4],
				exact: true,
				PlanFilter: isNewSubFlow ? "HasGroupBroadcast" : ""
			},
			{
				id: 11,
				label: "Transfer Credits",
				path: `${TeamsRoutes.TRANSFERS}/*`,
				component: withErrorBoundaries(Transfers, "Transfer Credits"),
				primaryIcon: TransferPrimaryIcon,
				primaryDarkIcon: TransferPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true
			},
			{
				id: 12,
				path: TeamsRoutes.CHANGE_PASSWORD,
				label: "Change password",
				primaryIcon: ChangepasswordPrimaryIcon,
				primaryDarkIcon: ChangepasswordPrimaryDarkIcon,
				component: withErrorBoundaries(Changepassword, "Change password"),
				isSideMenu: false,
				isUserMenu: true,
				authenticationRequired: true,
				roles: [1, 2, 3, 4]
			},
			{
				id: 13,
				path: `${TeamsRoutes.SETTINGS}/*`,
				label: "Settings",
				component: withErrorBoundaries(Settings, "Settings"),
				primaryIcon: SettingsPrimaryIcon,
				primaryDarkIcon: SettingsPrimaryDarkIcon,
				isSideMenu: false,
				isUserMenu: true,
				authenticationRequired: true,
				roles: [1, 2, 3, 4],
				exact: true
			},
			{
				id: 14,
				path: TeamsRoutes.PROFILE,
				label: "Profile",
				component: withErrorBoundaries(Profile, "Profile"),
				isSideMenu: false,
				authenticationRequired: true,
				roles: [1, 2, 3, 4]
			},
			{
				id: 15,
				path: TeamsRoutes.TIERS,
				label: "Phonelines",
				component: withErrorBoundaries(Tiers, "Plans"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1]
			},
			{
				id: 16,
				path: TeamsRoutes.FEATURES,
				label: "Features",
				component: withErrorBoundaries(Features, "Features"),
				primaryIcon: FeaturesPrimaryIcon,
				primaryDarkIcon: FeaturesPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1]
			},
			{
				id: 17,
				label: "",
				path: TeamsRoutes.ADD_PHONE_NUMBER,
				component: withErrorBoundaries(AddPhoneNumber, "Add Number"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 18,
				label: "",
				path: TeamsRoutes.PAYMENT_STATUS,
				component: withErrorBoundaries(PaymentStatusComponent, "Payment Status"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 18,
				label: "",
				path: TeamsRoutes.RECHARGE,
				component: withErrorBoundaries(Recharge, "Recharge"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 20,
				label: "Alerts",
				path: TeamsRoutes.ALERTS,
				component: withErrorBoundaries(AlertsComponent, "Alerts"),
				primaryIcon: AlertsPrimaryIcon,
				primaryDarkIcon: AlertsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 21,
				label: "Rehost Phone Number",
				path: TeamsRoutes.REHOST,
				component: withErrorBoundaries(AddPhoneNumber, "Rehost"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 22,
				label: "Automation",
				path: `${TeamsRoutes.AUTOMATION_RULES}/*`,
				component: withErrorBoundaries(AutoAlertRules, "Automation Rules"),
				roles: [2, 3, 4],
				primaryIcon: AutomationPrimaryIcon,
				primaryDarkIcon: AutomationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				exact: true,
				PlanFilter: "HasAccessAutoReplies",
			},
			{
				id: 23,
				label: "Falkon Sign",
				path: TeamsRoutes.FALKON_DOCS,
				component: withErrorBoundaries(SecureDocs, "Falkon Sign"),
				primaryIcon: FalkonDocPrimaryIcon,
				primaryDarkIcon: FalkonDocIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true,
				PlanFilter: "HasAccessToSecureDoc",
			},
			{
				id: 24,
				label: "Templates",
				path: `${TeamsRoutes.TEMPLATES}/*`,
				component: withErrorBoundaries(TemplateComponent, "Templates"),
				primaryIcon: TemplatesPrimaryIcon,
				primaryDarkIcon: TemplatesPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 25,
				label: "Import Contacts",
				path: TeamsRoutes.IMPORT_CONTACTS,
				component: withErrorBoundaries(ImportContactsContainer, "import-contacts"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 26,
				label: "Plan History",
				path: TeamsRoutes.PHONE_NUMBERS_PLAN_HISTORY,
				component: withErrorBoundaries(PlansHistoryComponent, "plan-history"),
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 27,
				label: "Plan History",
				path: TeamsRoutes.PLANS_PLAN_HISTORY,
				component: withErrorBoundaries(PlansHistoryComponent, "plan-history"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 28,
				path: TeamsRoutes.KAFKA_CLUSTER,
				label: "Kafka Cluster",
				component: withErrorBoundaries(kafkaComponent, "Kafka Cluster"),
				primaryIcon: KafkaPrimaryIcon,
				primaryDarkIcon: KafkaPrimaryDarkIcon,
				isSideMenu: true,
				authenticationRequired: true,
				roles: [1]
			},
			{
				id: 29,
				label: "Import Contacts from Excel",
				path: TeamsRoutes.IMPORT_CONTACTS_EXCEL,
				component: withErrorBoundaries(StepperImportNewComponent, "import-contacts-excel"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 30,
				label: "Import Contacts Outlook Login Teams",
				path: TeamsRoutes.TEAMS_LOGIN_PAGE,
				component: withErrorBoundaries(MicrosoftLoginStart, "import-contacts-outlook-login"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 31,
				label: "Import Contacts Outlook Login Teams",
				path: TeamsRoutes.TEAMS_CONCENTPOPUP_END,
				component: withErrorBoundaries(MicrosoftLoginConsentEnd, "import-contacts-outlook-login"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 32,
				label: "Import Contacts Outlook Login Teams",
				path: TeamsRoutes.TEAMS_LOGIN_PAGE_SSO,
				component: withErrorBoundaries(MicrosoftLoginStartSSO, "teams-outlook-login"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
				exact: true
			},
			{
				id: 33,
				label: "Import Contacts Outlook Login Teams",
				path: TeamsRoutes.TEAMS_CONCENTPOPUP_END_SSO,
				component: withErrorBoundaries(MicrosoftLoginConsentEndSSO, "teams-outlook-login"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
				exact: true
			},
			{
				id: 34,
				label: "Secure Files",
				path: `${TeamsRoutes.SECURE_FILE}/*`,
				component: withErrorBoundaries(SecureFiles, "Secure file"),
				primaryIcon: SecureFilePrimaryIcon,
				primaryDarkIcon: SecureFilePrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				PlanFilter: "HasAccessToSecureFiles"
			},
			{
				id: 35,
				label: "Secure Files Redirect",
				path: TeamsRoutes.SECURE_FILE_REDIRECT,
				component: withErrorBoundaries(SecureFileEmailAuthentication, "Secure file redirect"),
				primaryIcon: SecureFilePrimaryIcon,
				primaryDarkIcon: SecureFilePrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 36,
				label: "Reports",
				path: TeamsRoutes.REPORTS,
				component: withErrorBoundaries(Reports, "Reports"),
				roles: [3],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
			},
			{
				id: 37,
				label: "Reports",
				path: TeamsRoutes.REPORTS,
				component: withErrorBoundaries(Reports, "Reports"),
				roles: [2, 4],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				hasSubRoutes: true,
				children: [{
					id: 1,
					label: "Broadcast & Schedule Logs",
					subRouteLabel: "Schedule Broadcast Logs",
					path: TeamsRoutes.REPORTS,
					component: withErrorBoundaries(Reports, "Reports"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 2,
					label: "Secure Chat - Message Logs",
					subRouteLabel: "Secure Chat - Message Logs",
					path: TeamsRoutes.SECURE_CHAT_MESSAGE_LOGS,
					component: withErrorBoundaries(SecureChatMessageLogs, "SecureChat Message-Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 3,
					label: "Message Logs",
					subRouteLabel: "Message-logs",
					path: TeamsRoutes.MESSAGE_LOGS,
					component: withErrorBoundaries(MessageLogs, "Message-Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 4,
					label: "Credit Logs",
					subRouteLabel: "Credit Logs",
					path: TeamsRoutes.CreditLog,
					component: withErrorBoundaries(CreditLogsComponent, "Reports - Credit Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true,
					hide: isNewSubFlow
				},
				{
					id: 5,
					label: "Opt-Out List",
					subRouteLabel: "Opt-Out List",
					path: TeamsRoutes.OPTOUT_POLICY,
					component: withErrorBoundaries(OptOutPolicy, "Opt-Out List"),
					roles: [2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 6,
					label: "Blocked List",
					subRouteLabel: "Blocked List",
					path: TeamsRoutes.BLOCKED_CONTACTS_LIST,
					component: withErrorBoundaries(BlockedContact, "Blocked List"),
					roles: [2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true,
					hide: isNewSubFlow ? "HasBlockList" : false
				},
				{
					id: 7,
					label: "Export History",
					subRouteLabel: "Export History",
					path: TeamsRoutes.ExportReport,
					component: withErrorBoundaries(ExportMsgLogsComponent, "Reports - Export History"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 8,
					label: "Secure Chat Export History",
					subRouteLabel: "Secure Chat - Export History",
					path: TeamsRoutes.SecureChat_ExportReport,
					component: withErrorBoundaries(SecureChatExportMsgLogsComponent, "Secure Chat - Export History"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				}
				].filter(x => isNewSubFlow ? !x.hide === isNewSubFlow : x)
			},
			{
				id: 38,
				label: "Credit Logs",
				path: TeamsRoutes.CreditLog,
				component: withErrorBoundaries(CreditLogsComponent, "Credit Logs"),
				roles: [1],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
			},
			{
				id: 39,
				label: "Add Plan",
				path: TeamsRoutes.ADD_PLAN,
				component: withErrorBoundaries(ViewTierComponent, "Add Plan"),
				roles: [1],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{

				id: 40,
				label: "Integrations",
				path: TeamsRoutes.INTEGRATIIONS,
				component: withErrorBoundaries(Integrations, "Integrations"),
				roles: [2, 4],
				primaryIcon: IntegrationPrimaryIcon,
				primaryDarkIcon: IntegrationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				isUserMenu: false,
				exact: true
			},
			////teams channel setup--------------------------------------
			{
				id: 41,
				label: "Clio ",
				path: TeamsRoutes.CLIO,
				component: withErrorBoundaries(ClioSetup, "clio"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true

			},
			{
				id: 42,
				label: "Clio-pop-up ",
				path: TeamsRoutes.CLIO_POPUP,
				component: withErrorBoundaries(ClioPopup, "clio-popup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 43,
				label: "Clio-Callback ",
				path: TeamsRoutes.CLIO_CALLBACK,
				component: withErrorBoundaries(ClioCallback, "clio-Callback"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 44,
				label: "HubSpot ",
				path: TeamsRoutes.HUBSPOT,
				component: withErrorBoundaries(HubSpotSetup, "HubSpot"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true

			},
			{
				id: 45,
				label: "HubSpot-pop-up ",
				path: TeamsRoutes.HUBSPOT_POPUP,
				component: withErrorBoundaries(HubSpotPopup, "HubSpot-popup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 46,
				label: "HubSpot-Callback ",
				path: TeamsRoutes.HUBSPOT_CALLBACK,
				component: withErrorBoundaries(HubSpotCallback, "HubSpot-Callback"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 47,
				label: "Slack Channel Setup",
				path: TeamsRoutes.SLACK,
				component: withErrorBoundaries(SlackChannelSetup, "Slack Channel Setup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},
			{
				id: 48,
				label: "Slack Channel popup",
				path: TeamsRoutes.SLACK_POPUP,
				component: withErrorBoundaries(SlackPopup, "Slack Channel popup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},
			{
				id: 49,
				label: "Slack-Callback ",
				path: TeamsRoutes.SLACK_CALLBACK,
				component: withErrorBoundaries(SlackCallback, "slack-Callback"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 50,
				label: "Login",
				path: TeamsRoutes.SIGN_IN,
				component: withErrorBoundaries(Login, "Login"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 51,
				label: "SignUp",
				path: TeamsRoutes.SIGN_UP,
				component: withErrorBoundaries(Signup, "Signup"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 52,
				label: "2FA",
				path: TeamsRoutes.TWO_FACTOR_AUTHENTICATION,
				component: withErrorBoundaries(TwofactorAuthentication, "2Fa"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 53,
				label: "Forgot Password",
				path: TeamsRoutes.FORGOT_PASSWORD,
				component: withErrorBoundaries(ForgotPassword, "forgotPassword"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 54,
				label: "Reset Password",
				path: TeamsRoutes.RESET_PASSWORD_NEW,
				component: withErrorBoundaries(ResetPassword, "resetPassword"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 55,
				label: "SSO Error",
				path: TeamsRoutes.SSO_ERROR_PAGE,
				component: withErrorBoundaries(SsoInactive, "ssoError"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 56,
				label: "Face Registration",
				path: TeamsRoutes.FACE_REGISTRATION,
				component: withErrorBoundaries(FaceRegister, "faceRegistartion"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 57,
				label: "Face Verification",
				path: TeamsRoutes.FACE_VERIFICATION,
				component: withErrorBoundaries(FaceVerification, "faceVerification"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},


			{
				id: 58,
				label: "Outlook Intigration",
				path: TeamsRoutes.OUTLOOK,
				component: withErrorBoundaries(OutlookSetUp, "Outlook intigration"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 59,
				label: "Outlook popup",
				path: TeamsRoutes.OUTLOOK_POPUP,
				component: withErrorBoundaries(OutlookPopup, "Outlook popup"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 60,
				label: "Outlook callback",
				path: TeamsRoutes.OUTLOOK_CALLBACK,
				component: withErrorBoundaries(OutlookCallback, "Outlook callback"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 61,
				label: "Falkon AI",
				path: TeamsRoutes.FALKON_AI,
				component: withErrorBoundaries(FalkonAi, "Falkon AI"),
				primaryIcon: FalkonAiPurpleIcon,
				primaryDarkIcon: FalkonAiPurpleIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 62,
				label: "Falkon Sign",
				path: TeamsRoutes.FALKON_DOCS_UPLOADS,
				component: withErrorBoundaries(SecureDocsUploads, "Falkon Sign Uploads"),
				primaryIcon: FalkonDocPrimaryIcon,
				primaryDarkIcon: FalkonDocIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 63,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_SUCCESS,
				component: withErrorBoundaries(DisplaySuccessMaessageComponent, "Falkon Sign Configure Success"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 64,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_OTP,
				component: withErrorBoundaries(FalkonSecureDocOtp, "Falkon Sign Otp"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 65,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_END_USER_SIGN,
				component: withErrorBoundaries(EndUserSigningComponent, "Falkon Sign End User Sign"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 66,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_END_USER_SIGN_SUCCESS,
				component: withErrorBoundaries(DisplaySignerSuccessMaessageComponent, "Falkon Sign End User Sign Success"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 67,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_VERIFY_OTP,
				component: withErrorBoundaries(FalkonSignedSecureDocOtp, "Falkon Sign End User Verify OTP"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 68,
				label: "",
				path: TeamsRoutes.FALKON_DOCS_COMPLETED,
				component: withErrorBoundaries(CompletedPDFViewerComponent, "Completed Falkon Sign"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 69,
				label: "New Organizations",
				path: TeamsRoutes.NEW_ORGANIZATION,
				component: withErrorBoundaries(NewOrganization, "New Organizations"),
				primaryIcon: OrganizationsPrimaryIcon,
				primaryDarkIcon: OrganizationsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 70,
				label: "New Phone Numbers",
				path: TeamsRoutes.NEW_PhONE_NUMBER,
				component: withErrorBoundaries(NewPhoneNumbers, "new Phone Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 71,
				label: "New Users",
				path: TeamsRoutes.NEW_USERS,
				component: withErrorBoundaries(NewUsers, "New Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 72,
				label: "New Plans",
				path: TeamsRoutes.NEW_PLANS,
				component: withErrorBoundaries(NewPlans, "new Plans"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true
			},
			{
				id: 73,
				label: "Add plan",
				path: TeamsRoutes.ADD_NEW_PLAN,
				component: withErrorBoundaries(CreateEditPlan, "createOrEditPlan"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 74,
				label: "New Recharge",
				path: TeamsRoutes.NEW_RECHARGE,
				component: withErrorBoundaries(NewRecharge, "New Reacherge"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 75,
				label: "New Add Phone Numbers",
				path: TeamsRoutes.NEW_ADD_PHONE_NUMBER,
				component: withErrorBoundaries(NewAddPhoneNumber, "NewAddPhoneNumbers"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 76,
				label: "Seat History",
				path: TeamsRoutes.ORGANIZATION_PLAN_HISTORY,
				component: withErrorBoundaries(OrgPlanHistoryComponent, "Seat-history"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 77,
				label: "",
				path: TeamsRoutes.NEW_PAYMENT_STATUS,
				component: withErrorBoundaries(NewPaymentStatus, "Payment Status"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 1120,
				label: "Import Scheduled Messages",
				path: TeamsRoutes.IMPORT_SCHEDULED_MESSAGES,
				component: withErrorBoundaries(ImportScheduleMessages, "Import Scheduled Messages"),
				primaryIcon: FalkonAiPurpleIcon,
				primaryDarkIcon: FalkonAiPurpleIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 78,
				label: "Account & Billing",
				path: `${TeamsRoutes.ACCOUNT_BILLING}`,
				component: withErrorBoundaries(AccountBilling, "Account Billing"),
				primaryIcon: TemplatesPrimaryIcon,
				primaryDarkIcon: TemplatesPrimaryDarkIcon,
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: true,
				hide: isNewSubFlow ? false : true
			},
			{
				id: 79,
				label: "Custom Attributes",
				path: TeamsRoutes.CUSTOM_ATTRIBUTES,
				component: withErrorBoundaries(CustomAttributesComponent, "Custom-attributes"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 80,
				label: "Web Form",
				path: TeamsRoutes.WEBFORM,
				component: withErrorBoundaries(WebForm, "Web Form"),
				roles: [2, 4],
				primaryIcon: IntegrationPrimaryIcon,
				primaryDarkIcon: IntegrationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: false,
			},
			{
				id: 81,
				label: "Web-Form History",
				path: TeamsRoutes.WEB_FORM_HISTORY,
				component: withErrorBoundaries(WebFormHistory, "Web-Form History"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 82,
				label: "Bulk Add Users",
				path: TeamsRoutes.NEW_USERS_IMPORT,
				component: withErrorBoundaries(ImportUsersComponent, "Bulk Add Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: isNewSubFlow ? false : true
			},
			{
				id: 83,
				label: "Bulk Host Numbers",
				path: TeamsRoutes.NEW_PHONE_NUMBER_BULK_IMPORT,
				component: withErrorBoundaries(NewNumberBulkImportComponent, "Bulk Host Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: isNewSubFlow ? false : true
			},
			{
				id: 84,
				label: "Import Reports",
				path: TeamsRoutes.NEW_PHONE_NUMBER_IMPORT_REPORTS,
				component: withErrorBoundaries(PhoneHostImportReports, "Import Reports"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: isNewSubFlow ? false : true
			},
			{
				id: 85,
				label: "User Import Reports",
				path: TeamsRoutes.NEW_USERS_IMPORT_REPORTS,
				component: withErrorBoundaries(UserImportReports, "User Import Reports"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: isNewSubFlow ? false : true
			}
		].filter(x => !x.hide);
		existing_routes = routes;
		user_id = userId;
	}
	return existing_routes

}

export const getSideMenusTeams = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	let Routes = TeamRoutes();
	const AiSettings = store.getState().Settings.Settings;
	if (AiSettings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() != "true") {
		Routes = Routes.filter(x => x.label !== "Falkon AI")
	}
	return Routes.filter(route => route.isSideMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

// export const getSideMenusBottom = (planMetrics: PlanMetrics): RouteModel[] => {
// 	return teamsRoutes.filter(route => route.isSideMenu && route.IsBottomIcon && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]))
// }

export const getUserMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	return TeamRoutes().filter(route => route.isUserMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getAuthorisedRoutesTeams = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	return TeamRoutes().filter(route => route.authenticationRequired && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUnAuthorisedRoutesTeams = (): RouteModel[] => {
	return TeamRoutes().filter(route => !route.authenticationRequired)
}